import React from "react";
import { Box, Typography } from "@mui/material";
import { useGetAccount } from "@api/v1/hooks/useAccounts";
import { goToAccount } from "@helpers/mainAppUrls";
import { LoadingSpinner, SelectContraAccount } from "@components";
import { useCashAccounts } from "@api/v1/hooks/useCashAccounts";
import { useAssignContraAccount } from "../hooks/useAssignContraAccount";

export interface Values {
  bankConnectionId?: number;
}

interface Props {
  depotId: number;
}

export const AssignContraAccount = ({ depotId }: Props) => {
  const { data: depot, isFetching: isDepotLoading } = useGetAccount(depotId);
  const { mutateAsync: assignContraAccount, isPending: assignmentInProgress } =
    useAssignContraAccount();

  const { data: accounts = [], isFetching: isAccountsLoading } =
    useCashAccounts(depot?.bankConnectionType || "FIN_API", {
      enabled: !!depot?.bankConnectionType,
    });

  const handleFinish = async (contraAccountId?: number) => {
    if (!depot?.id || !contraAccountId) return;
    await assignContraAccount({
      id: depot.id,
      contraAccountId: contraAccountId,
    });
    goToAccount(depot.id);
  };

  if (!depot)
    return (
      <Box display="flex" justifyContent="center">
        <LoadingSpinner width={185} size="large" />
      </Box>
    );
  if (!depot.bankConnectionType)
    return (
      <Typography data-testid="no-bank-connection">
        Account must have bank connection
      </Typography>
    );

  return (
    <SelectContraAccount
      accounts={accounts}
      currentDepot={{
        accountNumber: depot.accountNumber,
        iban: depot.iban,
        bankConnectionId: depot.bankConnectionId,
        bankConnectionType: depot.bankConnectionType,
        name: depot.name,
      }}
      idType="LOCAL"
      showNoAccountOption={false}
      onSubmit={handleFinish}
      isFetching={assignmentInProgress || isDepotLoading || isAccountsLoading}
      defaultId={depot.contraAccountId}
    />
  );
};
